import { coreInitiativesLinksGetAsyncSlice } from './get';
import { coreInitiativesLinksPostAsyncSlice } from './post';

export const { requestGetCoreInitiativesLinks, resetGetCoreInitiativesLinks } =
	coreInitiativesLinksGetAsyncSlice.asyncActionCreators;

export const { requestPostCoreInitiativesLinks, resetPostCoreInitiativesLinks } =
	coreInitiativesLinksPostAsyncSlice.asyncActionCreators;

export * from './_id/actions';
